import { defineMessages } from 'react-intl';

export const scope = 'app.components.Profile';

export default defineMessages({
  profile: {
    id: `${scope}.profile`,
    defaultMessage: 'Profilo',
  },
  password: {
    id: `${scope}.password`,
    defaultMessage: 'Password',
  },
  api: {
    id: `${scope}.api`,
    defaultMessage: 'Chiave API',
  },
  apiInputLabel: {
    id: `${scope}.apiInputLabel`,
    defaultMessage: 'Chiave API personale',
  },
  landingpage: {
    id: `${scope}.landingpage`,
    defaultMessage: 'Landing page',
  },
  rebrand: {
    id: `${scope}.rebrand`,
    defaultMessage: 'Tema e logo',
  },
  rebrandThemeLabel: {
    id: `${scope}.rebrandThemeLabel`,
    defaultMessage: 'Scegli la palette di colori',
  },
  rebrandLogoLabel: {
    id: `${scope}.rebrandLogoLabel`,
    defaultMessage: 'Carica il tuo logo personalizzato',
  },
  rebrandSubmit: {
    id: `${scope}.rebrandSubmit`,
    defaultMessage: 'Salva preferenze',
  },
  requestNewApiKey: {
    id: `${scope}.requestNewApiKey`,
    defaultMessage: 'Crea una nuova chiave API',
  },
  alertSuccess: {
    id: `${scope}.alertSuccess`,
    defaultMessage: 'Aggiornamento avvenuto con successo',
  },
  alertError: {
    id: `${scope}.alertError`,
    defaultMessage: 'Si sono verificati degli errori, controllare i dati inseriti',
  },
  businessName: {
    id: `${scope}.businessName`,
    defaultMessage: 'Ragione sociale'
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Nome completo',
  },
  requiredField: {
    id: `${scope}.requiredField`,
    defaultMessage: 'Questo campo è obbligatorio',
  },
  phone: {
    id: `${scope}.phone`,
    defaultMessage: 'Numero di telefono',
  },
  phoneNotValid: {
    id: `${scope}.phoneNotValid`,
    defaultMessage: 'Indicare un numero di telefono valido',
  },
  contactInfo: {
    id: `${scope}.contactInfo`,
    defaultMessage: 'Informazioni di contatto',
  },
  updateProfile: {
    id: `${scope}.updateProfile`,
    defaultMessage: 'Aggiorna profilo',
  },
  updatePassword: {
    id: `${scope}.updatePassword`,
    defaultMessage: 'Aggiorna password',
  },
  currentPassword: {
    id: `${scope}.currentPassword`,
    defaultMessage: 'Password attuale',
  },
  currentPasswordErrorEmpty: {
    id: `${scope}.currentPasswordErrorEmpty`,
    defaultMessage: `Indicare l'attuale password`,
  },
  newPassword: {
    id: `${scope}.newPassword`,
    defaultMessage: 'Nuova password',
  },
  newPasswordErrorMinLength: {
    id: `${scope}.newPasswordErrorMinLength`,
    defaultMessage: 'La nuova password deve essere almeno di 8 caratteri',
  },
  confirmPassword: {
    id: `${scope}.confirmPassword`,
    defaultMessage: 'Conferma password',
  },
  confirmPasswordErrorNotEqual: {
    id: `${scope}.confirmPasswordErrorNotEqual`,
    defaultMessage: 'Le due password non coincidono',
  },
});
